export default "__VITE_ASSET__dYxwmeff__"